var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"id":"dropdown-locale","text":_vm.localeDisplay,"variant":"link","right":""}},_vm._l((Object.entries(_vm.locales)),function(ref){
var id = ref[0];
var locale = ref[1];
return _c('b-dropdown-item',{key:id,attrs:{"active":id === _vm.localeId},on:{"click":function($event){return _vm.setLocale(id)}}},[_vm._v(" "+_vm._s(_vm.$t(locale.display))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }